import { createRouter, createWebHistory } from 'vue-router'
import { useSession } from '../stores/session'

const routes = [
  { path: '/login', component: () => import('../pages/LoginPage.vue'), meta: { guest: true } },
  { path: '/register', component: () => import('../pages/RegisterPage.vue'), meta: { guest: true } },
  { path: '/', component: () => import('../pages/SectionsPage.vue') },
  { path: '/topics/:slug', component: () => import('../pages/TopicPage.vue') },
  { path: '/attempts/:id', component: () => import('../pages/AttemptPage.vue') },
  { path: '/attempts/:id/result', component: () => import('../pages/ResultPage.vue') },
  { path: '/me', component: () => import('../pages/MePage.vue') },
  { path: '/program', component: () => import('../pages/ProgramPage.vue'), meta: { public: true } },
  { path: '/memos', component: () => import('../pages/MemosPage.vue'), meta: { public: true } },
  { path: '/memos/:slug', component: () => import('../pages/MemosPage.vue'), meta: { public: true } },
]

const router = createRouter({ history: createWebHistory(), routes })

router.beforeEach(async (to) => {
  const session = useSession()
  if (!session.loaded) await session.load()
  if (to.meta.public) return true
  if (to.meta.guest) return session.signedIn ? '/' : true
  return session.signedIn ? true : { path: '/login', query: { next: to.fullPath } }
})

export default router
